import { React, Link, Image, styled, mq } from 'x'
import { Content, Row, Col } from 'components/common'

const Container = styled.div`
  padding: 0 0 100px 0;
  position: relative;

  ${mq.below('sm')} {
    padding: 0 0 60px 0;
  }
`
const Filters = styled(Row)`
  margin: 0 auto;
  max-width: 800px;

  > p {
    color: #2a2d58;
    margin: 0;
    padding-right: 5px;
  }
`
const Filter = styled(Col)`
  padding: 0;
  flex: 0 1 auto;
  padding-right: 5px;
`
const FilterLink = styled(Link)`
  color: #f1b860;
  transition: 0.3s all ease;
  &:hover {
    color: ${(props) => props.theme.primary};
  }
`

const PostTopicsList = (props) => {
  return (
    <Container>
      <Content>
        {props?.data?.filters && (
          <Filters>
            <p>Topics:</p>
            {props?.data?.filters.map((filter, index) => (
              <Filter key={filter.id}>
                <FilterLink to={props.globalData.formatLink(filter.link)}>
                  {filter.title}
                </FilterLink>
                {index < props?.data?.filters?.length - 1 && ', '}
              </Filter>
            ))}
          </Filters>
        )}
      </Content>
    </Container>
  )
}

export default PostTopicsList
